import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

import ToolbarActions from "../../common/table/action-toolbar.jsx";
import PaginationBar from "../../common/table/pagination-bar.jsx";
import { PageContentBox } from "../../common/page-content-box";
import ErrorsDialog from "../../common/dialogs/errors-dialog.jsx";
import ProgressDialog from "../../common/dialogs/progress-dialog.jsx";
import useIntegrationTable from "../../common/hooks/useIntegrationTable";

import IntegrationList from "./integration-list.jsx";

import "./styles.less";
import { downloadIntegrationData, uploadFullMatrix } from "../../../reducers/admin/integrationSlice.js";
import { selectUserScreenButton } from "../../../reducers/authSlice.js";
import { USER_SCREEN_BUTTONS } from "../../../utils/auth.js";
import UploadMatrixFullDialog from "./dialogs/upload-matrix-dialog-full.jsx";

const IntegrationSettingsPage = () => {
    const {
        rows, total, busy,
        searchString, setSearchString,
        pageNumber, setPageNumber,
        limitNumber, setLimitNumber,
        error, setError
    } = useIntegrationTable();

    const busyType = useSelector((state) => state.admin.integration.busyType);
    const dispatch = useDispatch();
    const intl = useIntl()
    const [manualIntegrOpen, setManualIntegrOpen] = useState(false)

    const toolbarActions = [
        {
            id: "title",
            title: <FormattedMessage id="integration-settings-page.toolbar.text" />,
            type: "text",
            position: "begin",
        },
        {
            id: "search",
            type: "search",
            position: "end",
            value: searchString,
            callback: (value) => {
                setSearchString(value);
            },
        },
    ];

    const downloadButton = useSelector((state) => selectUserScreenButton(state, USER_SCREEN_BUTTONS.DOWNLOAD_INTEGR_DATA));

    if (downloadButton){
        toolbarActions.push(
            {
                id: "uploadMatrix",
                type: "button",
                position: "end",
                title: intl.formatMessage({ id: "integration-details-row.manual-integration.text" }),
                callback: () => {
                    handleOpenManualIntegrClick()
                }
            },
        )

        toolbarActions.push(
            {
                id: "download",
                type: "button",
                position: "end",
                title: downloadButton.title,
                callback: () => {
                    handleDownloadClick()
                }
            },
        )
    }

    const handleDownloadClick = () => {
        dispatch(downloadIntegrationData())
    }

    const handleOpenManualIntegrClick = () => {
        setManualIntegrOpen(true)
    }

    const handleApplyManualIntegrClick = async (formData) => {
        try {
            await dispatch(uploadFullMatrix({formData})).unwrap();
        } catch (error) {
            return
        }
        
        setManualIntegrOpen(false)
    }

    return (
        <PageContentBox className="integration-settings-page-content">
            <ToolbarActions toolbarActions={toolbarActions} />

            <IntegrationList
                integrationItems={rows}
                sx={{ marginTop: "60px" }}
                setError={setError} />

            <PaginationBar
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                limitNumber={limitNumber}
                setLimitNumber={setLimitNumber}
                total={total}
                sx={{ marginTop: "36px" }}
            />

            <ErrorsDialog
                error={error}
                open={error?.type === "error"}
                onClose={() => setError(null)}
            />

            <ProgressDialog
                open={busy}
                busyType={busyType}
            />

            <UploadMatrixFullDialog
                open={manualIntegrOpen}
                onClose={() => {
                    setManualIntegrOpen(false)
                }}
                onApply={handleApplyManualIntegrClick}
            />
        </PageContentBox>
    );
};

export default IntegrationSettingsPage;
